module.exports = __webpack_public_path__ + "static/img/美的晶焰万向洗碗机.ae0a74f6.png";